import type { UseCase } from '@/components/onboarding/types';
import type { Language } from '@/i18n/translations';

/**
 * 3 concrete starter prompts per use-case, shown inside the AI welcome
 * message. The intent is to give users an immediate "I can try this" moment.
 */
export const USECASE_EXAMPLE_PROMPTS: Record<UseCase, Partial<Record<Language, string[]>> & { en: string[] }> = {
  'it-infrastructure': {
    sv: [
      'Rita en AWS-topology med 3 tiers',
      'Visa en bird\'s-eye-vy av min infrastruktur',
      'Hjälp mig identifiera potentiella bottlenecks',
    ],
    en: [
      'Draw an AWS topology with 3 tiers',
      'Show a bird\'s-eye view of my infrastructure',
      'Help me identify potential bottlenecks',
    ],
  },
  'business-process': {
    sv: [
      'Bygg ett HR-onboarding-flöde med 4 godkännanden',
      'Rita en CI/CD-pipeline med approval-gates',
      'Gör ett support-ticket-flow med SLA-eskalering',
    ],
    en: [
      'Build an HR onboarding flow with 4 approvals',
      'Draw a CI/CD pipeline with approval gates',
      'Create a support ticket flow with SLA escalation',
    ],
  },
  'organization-chart': {
    sv: [
      'Skapa ett org-diagram: VD → VPs → team',
      'Rita en RACI för vi projekt',
      'Visa team-composition med roller och skills',
    ],
    en: [
      'Create an org chart: CEO → VPs → teams',
      'Draw a RACI matrix for our project',
      'Show team composition with roles and skills',
    ],
  },
  'decision-tree': {
    sv: [
      'Bygg ett troubleshooting-träd för nätverksproblem',
      'Gör ett beslutsträd för kund-eligibility',
      'Skapa en interactive guide med 5 frågor',
    ],
    en: [
      'Build a troubleshooting tree for network issues',
      'Create a decision tree for customer eligibility',
      'Make an interactive guide with 5 questions',
    ],
  },
  'mind-map': {
    sv: [
      'Brainstorma runt nytt feature-lansering',
      'Rita en mindmap för vi produktvision',
      'Organisera min kursplanering med 4 teman',
    ],
    en: [
      'Brainstorm around a new feature launch',
      'Draw a mind map for our product vision',
      'Organize my course planning with 4 themes',
    ],
  },
  'project-planning': {
    sv: [
      'Skapa en 3-månaders roadmap med milstolpar',
      'Rita ett sprint-flow med blockers',
      'Gör en Kanban med 4 kolumner',
    ],
    en: [
      'Create a 3-month roadmap with milestones',
      'Draw a sprint flow with blockers',
      'Make a Kanban with 4 columns',
    ],
  },
  sandbox: {
    sv: [
      'Generera något kreativt — förvåna mig',
      'Rita en workflow i valfri stil',
      'Experimentera med oviktig visualisering',
    ],
    en: [
      'Generate something creative — surprise me',
      'Draw a workflow in any style',
      'Experiment with an unusual visualization',
    ],
  },
};
